<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">설정</h3>
      </v-toolbar>

      <v-flex xs12 v-if="loading">
        <v-card tile class="py-4 mt-2 card-shadow">
          <v-layout column>
            <v-flex xs12>로그아웃합니다.</v-flex>
            <v-flex xs12 class="mt-4">
              <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 v-else>
        <v-card tile class="pa-0 pb-0 mt-2 card-shadow" v-for="(list, index) of menu" :key="index">
          <v-list-tile ripple v-for="(item, itemIndex) of list" :key="itemIndex" @click="item.method">
            <v-list-tile-title class="body-2">{{ item.name }}</v-list-tile-title>
            <v-list-tile-action style="justify-content: flex-end;">
              <v-btn icon small>
                <v-icon size="16px">{{ item.icon }}</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Settings',
    computed: {
      ...mapGetters('user', [ 'social_type' ]),
    },
    data () {
      return {
        scrollY: 0,
        loading: false,
        menu: [
          [
            { name: '프로필 수정', method: () => this.$router.push({ name: 'Profile' }), icon: '$vuetify.icons.arrowRight' }
          ],
          [
            // { name: '공지사항', method: '', icon: '$vuetify.icons.arrowRight' },
            { name: '서비스 이용약관', method: () => this.$router.push({ name: 'TermsOfService' }), icon: '$vuetify.icons.arrowRight' },
            { name: '개인정보처리방침', method: () => this.$router.push({ name: 'PrivacyPolicy' }), icon: '$vuetify.icons.arrowRight' },
            { name: '버전 정보', method: event => event.preventDefault(), icon: '1.3' },
            { name: '자주 묻는 질문', method: () => this.$router.push({ name: 'FAQ' }), icon: '$vuetify.icons.arrowRight' },
          ],
          [
            { name: '로그아웃', method: () => this.logOut(), icon: '$vuetify.icons.arrowRight' },
          ],
        ],
      };
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      ...mapActions('user', [ 'signOutUser', 'setUser' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      logOut () {
        this.loading = true;
        this.signOutUser();
        window.localStorage.removeItem('jwt');
        if (window.native) {
          window.native.setJWT(null);
          this.setUser({
            idx: 0,
            token: '', // idToken, kakao access_token
            id: '',
            email: '',
            name: '',
            birthday: 0,
            social_type: '',
            profile_image: null,
            allow_mail: false,
            allow_push: false,
            bookmark_cnt: 0,
            subscribe_cnt: 0,
            phone: null,
            zipcode: null,
            address: null,
            detail_address: null,
            balance: 0,
            account_bank: '',
            account_number: 0,
            login_at: '',
            bookmarks_max_page: 2,
            bookmarks: [],
            wishes_max_page: 2,
            wish_cnt: 0,
            wishes: [],
          });
          this.$router.replace('/');
        } else if (typeof webkit !== 'undefined') {
          // eslint-disable-next-line
          webkit.messageHandlers.setJWT.postMessage(null);
          this.setUser({
            idx: 0,
            token: '', // idToken, kakao access_token
            id: '',
            email: '',
            name: '',
            birthday: 0,
            social_type: '',
            profile_image: null,
            allow_mail: false,
            allow_push: false,
            bookmark_cnt: 0,
            subscribe_cnt: 0,
            phone: null,
            zipcode: null,
            address: null,
            detail_address: null,
            balance: 0,
            account_bank: '',
            account_number: 0,
            login_at: '',
            bookmarks_max_page: 2,
            bookmarks: [],
            wishes_max_page: 2,
            wish_cnt: 0,
            wishes: [],
          });
          this.$router.replace('/');
        } else {
          let root = this;
          if (this.social_type === 'kakao') {
            console.log('signOutKaKao');
            try {
              // eslint-disable-next-line
              Kakao.Auth.logout();
              window.location.href = '/';
            } catch (e) {
              root.loading = false;
              console.error(e);
            }
          } else {
            firebase.auth().signOut().then(() => {
              console.log('signOutFirebase');
              window.location.href = '/';
            }).catch(error => {
              root.loading = false;
              console.log(error);
            });
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

</style>
